export const NORMAL_EXERCISE_TYPE = 'NormalExercise';
export const MULTIPLE_CHOICE_EXERCISE_TYPE = 'MultipleChoiceExercise';
export const isNormalExercise = exercise => exercise !== undefined && exercise.type === NORMAL_EXERCISE_TYPE;
export const isMultipleChoiceExercise = exercise => exercise !== undefined && exercise.type === MULTIPLE_CHOICE_EXERCISE_TYPE;